module.exports = __webpack_public_path__ + "img/ico-information.704d24f7.svg";